import { useEffect, useRef } from "react";
import { LAXMIMORNING } from "./Chart.config";
import { redJodi } from "../JodiCharts/Chart.config";

/* ---------- Skeleton Row ---------- */
const SkeletonRow = ({ colCount }) => (
  <tr>
    {Array.from({ length: colCount }).map((_, i) => (
      <td key={i} className="cc">
        <div className="tw-animate-pulse tw-h-8 tw-bg-gray-200 tw-rounded-md tw-m-1" />
      </td>
    ))}
  </tr>
);

const ShreeDevi = ({ chartData }) => {
  const tableEndRef = useRef(null);
  const colCount = 8; // Date + MON-SUN

  const isApiLoading = !chartData || chartData.length === 0;

  useEffect(() => {
    tableEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chartData]);

  return (
    <div>
      <table className="table fw-bold" border="collapse">
        <thead>
          <tr className="tw-text-center">
            <th className="cc">Date</th>
            <th className="cc">MON</th>
            <th className="cc">TUE</th>
            <th className="cc">WED</th>
            <th className="cc">THU</th>
            <th className="cc">FRI</th>
            <th className="cc">SAT</th>
            <th className="cc">SUN</th>
          </tr>
        </thead>
        <tbody>

          {/* ================= STATIC DATA ================= */}
          {Object.entries(LAXMIMORNING).map(([week, days], index) => {
            const splitDate = week.split(" ");

            return (
              <tr key={`static-${index}`}>
                <td className="cc td-width-13">
                  <div className="pana-chart-main">
                    <span className="result_date">{splitDate[0]}</span>
                    <span className="result_date">{splitDate[1]}</span>
                    <span className="result_date">{splitDate[2]}</span>
                  </div>
                </td>

                {Object.entries(days).map(([day, values], id) => {

                  // ✅ If ANY value matches redJodi, ALL values in cell turn red
                  const isAnyInRedJodi = values.some((value) =>
                    redJodi.map((j) => parseInt(j)).includes(parseInt(value))
                  );

                  return (
                    <td key={id} className="cc">
                      <div className="kalyan-chart-number-black">
                        {values.map((value, valueIndex) => (
                          <span
                            key={valueIndex}
                            className={`cp ${isAnyInRedJodi ? "text-danger" : "text-dark"}`}
                            style={{ color: isAnyInRedJodi ? "red" : "black" }}
                          >
                            {value ?? ""}
                          </span>
                        ))}
                      </div>
                    </td>
                  );
                })}
              </tr>
            );
          })}

          {/* ================= DYNAMIC DATA ================= */}
          {isApiLoading
            ? Array.from({ length: 3 }).map((_, i) => (
                <SkeletonRow key={`dynamic-skel-${i}`} colCount={colCount} />
              ))
            : chartData.map((item1) => {
                const filteredData = item1.data.filter(
                  (nestedItem) =>
                    nestedItem.relatedData[0] &&
                    nestedItem.relatedData[0].winningDigitFamily !== null,
                );

                if (filteredData.length === 0) return null;

                return (
                  <tr key={item1.id}>
                    <td className="cc td-width-13">
                      <div className="pana-chart-main">
                        <span className="result_date">
                          {item1.weekStartDay}
                        </span>
                        <span className="result_date"> to </span>
                        <span className="result_date">{item1.weekEndDay}</span>
                      </div>
                    </td>

                    {filteredData.map((nestedItem) => {
                      const value0 =
                        nestedItem.relatedData[0]?.winningDigit ?? "";
                      const family0 =
                        nestedItem.relatedData[0]?.winningDigitFamily ?? "";
                      const family1 =
                        nestedItem.relatedData[1]?.winningDigitFamily ?? "";
                      const value1 =
                        nestedItem.relatedData[1]?.winningDigit ?? "";

                      const combinedValue = `${nestedItem.relatedData[0]?.winningDigitFamily ?? ""}${
                        nestedItem.relatedData[1]?.winningDigitFamily ?? ""
                      }`;

                      const isInRedJodi = redJodi
                        .map((j) => parseInt(j))
                        .includes(parseInt(combinedValue) || 0);

                      return (
                        <td key={nestedItem.id} className="cc">
                          <div className="kalyan-chart-number-black">
                            <span
                              className={`cp ${isInRedJodi ? "text-danger" : "text-dark"}`}
                              style={{ color: isInRedJodi ? "red" : "black" }}
                            >
                              {value0}
                            </span>
                            <span
                              className={`cp ${isInRedJodi ? "text-danger" : "text-dark"}`}
                              style={{ color: isInRedJodi ? "red" : "black" }}
                            >
                              {family0}{family1}
                            </span>
                            <span
                              className={`cp ${isInRedJodi ? "text-danger" : "text-dark"}`}
                              style={{ color: isInRedJodi ? "red" : "black" }}
                            >
                              {value1}
                            </span>
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}

          {/* Dummy row for scroll */}
          <tr ref={tableEndRef} />
        </tbody>
      </table>
    </div>
  );
};

export default ShreeDevi;